module.exports = __webpack_public_path__ + "img/refresh.b0eb5c80.svg";